/* tslint:disable:max-line-length */
import React from 'react';
import { ReactComponent as FamousIcon } from './svg/famous.svg';
import { ReactComponent as DoubtIcon } from './svg/doubt.svg';
import { ReactComponent as HelloIcon } from './svg/hello.svg';
import { ReactComponent as RainbowIcon } from './svg/rainbow.svg';
import { ReactComponent as ShockedIcon } from './svg/shocked.svg';

interface IEmailTemplate {
  title: string;
  subject: string;
  body: string;
  previewText: string;
  listDescription: string;
  listIcon: React.ComponentType<any>;
}

export const EMAIL_TEMPLATES: Record<string, IEmailTemplate> = {
  fomo_generator: {
    title: 'Ultimate FOMO Generator',
    subject: 'Only 3 spots left',
    previewText: 'Now is your chance!',
    body: `<p>Psst {{first name}} … we just extended the deadline to apply!</p>
      <p><strong>Our exclusive product</strong> is getting extraordinary results but we aren’t ready to scale it to our whole audience just yet. Now is your chance to get in on the ground floor!</p>
      <p>It notifies you when somebody is searching for your products and services and automatically sends them targeted outreach to drive, qualify and convert leads.</p>
      <p>Doors are open to the next 3 qualified marketers to apply for a complete build and launch.</p>
      <p>The FINAL deadline  is today!</p> 
    `,
    listDescription:
      'This email makes people fear they are missing out on a once in a lifetime opportunity.',
    listIcon: ShockedIcon,
  },
  takeaway: {
    title: 'The Takeaway',
    subject: 'We’re rescinding our prior offer to you',
    previewText: 'Thanks for your consideration',
    body: `
      <p>{{first name}} - I wanted to reach out to you one more time regarding our prior offer. If I don't hear back from you, I’ll assume that the timing isn’t right and I won’t contact you again. </p>
      <p>If I can be of assistance, you can always contact me at the number below.</p>
    `,
    listDescription:
      'Disqualify the prospect for what you are trying to sell. Works great on prospects that are “on the fence”',
    listIcon: DoubtIcon,
  },
  end_of_period: {
    title: 'End of Month/Quarter/Year Blowout',
    subject: 'LIMITED TIME – End of Year Savings!',
    previewText: 'Act now for the best deals of the year!',
    body: `<p>Hi {{first name}},</p><p>Thanks so much for being a loyal {company} for all these years! To show our appreciation, we are pleased to offer you a discount on any design work you need help with before the end of the year. To claim this offer, just hit “reply” to this email before next Monday with any work you need before year-end and we’ll take 30% off when we send the final invoice. It’s our way of saying: Happy Fourth Quarter!</p><p>Wishing you all the best.</p><p>PS: You know how busy it gets around Q4 which means, we can’t offer this discount after next Monday (even if we want to) so be sure to hit “reply” right away and we’ll get you on the calendar. Cheers!</p>`,
    listDescription:
      'Everyone loves a deal. Generate excitement by making people feel like they are getting a once-in-a-year savings.',
    listIcon: FamousIcon,
  },
  prices_going_up: {
    title: 'Prices are Going Up',
    subject: "You're selected for price savings, {{first name}}.",
    previewText: 'Act now before prices go up for good',
    body: `<p>Good news, {{first name}}!</p><p>You've been selected to apply for big price savings before MobileMonkey raises prices in April.</p><p>We've been hard at work on new things like roboBDR™ and Unicorn Lead Detection. Our new customer onboarding calendars are booking up fast!</p><p>Today we're reaching out to a few select businesses to lock in prices before the price goes up.</p>
    <p>Book your call to meet with an expert to design a custom plan to grow your business with sales automation outreach solutions at locked in rates.</p>
    <p>Grab your spot on the calendar today!</p>
    <p>PS - Don't see an available time today? Book your call ASAP and we'll honor this deal.</p>`,
    listDescription: 'Last chance to lock in last year’s prices for life!',
    listIcon: RainbowIcon,
  },
  scratch: {
    title: 'Start from scratch',
    subject: '',
    previewText: '',
    body: '',
    listIcon: HelloIcon,
    listDescription: '',
  },
};
